
export const RUN_COMMAND_START = "RUN_COMMAND - Start";
export const RUN_COMMAND_COMPLETED = "RUN_COMMAND - Completed";
export const RUN_COMMAND_FAILED = "RUN_COMMAND - Failed";
